import type { WorkflowStudy } from './workflowStudies';

// Thai translations of the same 18 proposed English workflow scenarios.
export const workflowStudies: WorkflowStudy[] = [
  {
    "id": "retail",
    "industry": "ค้าปลีกและอีคอมเมิร์ซ",
    "function": "บริการลูกค้า",
    "title": "ลูกค้าตามพัสดุที่ส่งออกไปแล้ว",
    "summary": "เชื่อมคำถามเรื่องคำสั่งซื้อ ข้อมูลขนส่ง และการคืนสินค้าไว้ที่เดียว",
    "situation": "ลูกค้าถามทาง WhatsApp เรื่องพัสดุที่แยกส่ง ทีมต้องหาหมายเลขติดตามจากร้านค้า อีเมลคลังสินค้า และคำขอคืนสินค้าในกล่องข้อความ คำตอบทั่วไปว่าส่งแล้วทำให้เกิดข้อร้องเรียนเพิ่ม",
    "steps": [
      "จับคู่คำถามกับลูกค้าที่ตรวจสอบแล้วและคำสั่งซื้อ ดึงรายการสินค้า การส่งบางส่วน และสถานะขนส่งล่าสุด",
      "ตอบคำถามสถานะจากข้อมูลนั้น เปิดเคสเมื่อพัสดุค้าง สินค้าขาด หรือข้อมูลส่งมอบขัดแย้ง",
      "แนบบทสนทนาและหลักฐาน มอบหมายเจ้าของเคส และแจ้งลูกค้าเมื่อสถานะเปลี่ยน"
    ],
    "control": "การคืนเงิน เปลี่ยนที่อยู่ และข้อพิพาทต้องได้รับอนุมัติ หากข้อมูลติดตามเก่าหรือยืนยันตัวตนไม่ได้ ให้ส่งต่อคนตรวจสอบ",
    "outcome": "ลูกค้าได้รับขั้นตอนถัดไปที่ชัดเจน ทีมใช้เวลาแก้ข้อยกเว้นแทนการรวบรวมข้อมูลคำสั่งซื้อ",
    "measures": [
      "เวลาจัดการต่อคำถาม",
      "จำนวนการติดต่อซ้ำต่อคำสั่งซื้อ",
      "ระยะเวลาค้างของเคสส่งมอบ"
    ],
    "systems": "ร้านค้าออนไลน์, ข้อมูลขนส่ง, ระบบช่วยเหลือลูกค้า, WhatsApp Business"
  },
  {
    "id": "accounting",
    "industry": "บัญชีและการเงิน",
    "function": "การเงินและกระแสเงินสด",
    "title": "ตรวจใบแจ้งหนี้ซ้ำก่อนเข้าคิวจ่าย",
    "summary": "นำใบแจ้งหนี้จากกล่องอีเมลร่วมเข้าสู่คิวอนุมัติที่ตรวจแล้ว",
    "situation": "ผู้ขายส่ง PDF ซ้ำ พนักงานส่งรูป และใบสั่งซื้ออยู่ในอีกชีต เมื่อสิ้นเดือนฝ่ายการเงินต้องตรวจรายการซ้ำและตามใบรับสินค้าขณะใกล้กำหนดจ่าย",
    "steps": [
      "เก็บต้นฉบับและดึงชื่อผู้ขาย เลขใบแจ้งหนี้ วันที่ สกุลเงิน ภาษี และยอดรายการ",
      "ตรวจรายการซ้ำและจับคู่ใบสั่งซื้อกับใบรับสินค้า ส่งจำนวน ราคา และภาษีที่ไม่ตรงเข้าคิวตรวจ",
      "สร้างร่างรายการจ่ายพร้อมต้นฉบับ ส่งให้เจ้าของงบ และติดตามการอนุมัติตามวันครบกำหนด"
    ],
    "control": "คนตรวจข้อมูลที่ไม่แน่นอน การเปลี่ยนบัญชีธนาคาร และใบแจ้งหนี้ที่จับคู่ไม่ได้ ทีมการเงินที่มีสิทธิ์เป็นผู้ปล่อยจ่าย",
    "outcome": "ได้คิวรายการจ่ายที่ตรวจสอบย้อนหลังได้ พร้อมระบุรายการซ้ำและข้อมูลไม่ตรงก่อนจ่าย",
    "measures": [
      "นาทีที่ใช้ต่อใบแจ้งหนี้",
      "รายการที่ยังรออนุมัติเมื่อครบกำหนด",
      "รายการซ้ำที่พบก่อนบันทึก"
    ],
    "systems": "กล่องอีเมลร่วม, ที่เก็บเอกสาร, ข้อมูลจัดซื้อ, Xero หรือระบบบัญชี"
  },
  {
    "id": "manufacturing",
    "industry": "การผลิต",
    "function": "ปฏิบัติการและการส่งมอบ",
    "title": "พบชิ้นส่วนที่ขาดก่อนเริ่มผลิต",
    "summary": "เห็นวัสดุที่ขาดก่อนกลายเป็นเรื่องเร่งด่วน",
    "situation": "แผนผลิตคาดว่าผู้ขายจะส่งทัน ฝ่ายจัดซื้อมีวันส่งใหม่ในอีเมล แต่ผู้วางแผนใช้ข้อมูลสัปดาห์ก่อน จึงพบของขาดเมื่อปล่อยใบงาน",
    "steps": [
      "เทียบใบงานและความต้องการวัสดุกับสต็อกและกำหนดรับของที่ยืนยันแล้ว",
      "ระบุของขาดตามวันที่ต้องใช้ เชื่อมงานที่ได้รับผลกระทบกับใบสั่งซื้อและกำหนดส่ง",
      "มอบหมายฝ่ายจัดซื้อให้ติดตามวันส่งใหม่ และให้ผู้วางแผนเห็นรายการผลกระทบล่าสุด"
    ],
    "control": "ผู้วางแผนอนุมัติการเลื่อนงานและวัสดุทดแทน ข้อมูลสต็อกที่ขาดหรือเก่าต้องแสดงชัดเจน ระบบไม่สร้างยอดที่ไม่มีหลักฐาน",
    "outcome": "ฝ่ายจัดซื้อและผู้วางแผนใช้รายการของขาดเดียวกัน พร้อมข้อมูลเพื่อตัดสินใจ",
    "measures": [
      "ของขาดที่พบก่อนปล่อยงาน",
      "เวลาจัดทำรายงานของขาด",
      "งานล่าช้าเพราะวัสดุ"
    ],
    "systems": "ERP, สินค้าคงคลัง, ใบสั่งซื้อ, อีเมลผู้ขาย"
  },
  {
    "id": "logistics",
    "industry": "ขนส่งและกระจายสินค้า",
    "function": "การเงินและกระแสเงินสด",
    "title": "เตรียมงานส่งมอบเสร็จให้พร้อมออกใบแจ้งหนี้",
    "summary": "รวมหลักฐานส่งมอบเป็นชุดเอกสารเรียกเก็บเงิน",
    "situation": "ใบส่งของที่ลงชื่อแล้วมาเป็นรูปจากโทรศัพท์ บางใบไม่มีเลขงาน บางใบระบุของขาด ฝ่ายขนส่งต้องโทรถามคนขับ ฝ่ายบัญชีรอและงานยังออกบิลไม่ได้",
    "steps": [
      "เก็บหลักฐานตามเลขขนส่ง ตรวจลายเซ็น เวลา และเอกสารแนบที่จำเป็น",
      "เทียบจำนวนส่งกับงาน ส่งหลักฐานอ่านไม่ออก ความเสียหาย และของขาดให้ฝ่ายขนส่งตรวจ",
      "รวบรวมชุดเอกสารที่อนุมัติ สร้างร่างใบแจ้งหนี้ และติดตามงานที่ยังขาดหลักฐาน"
    ],
    "control": "เจ้าของงานขนส่งแก้ข้อมูลไม่ตรง การอัปโหลดซ้ำแก้ในงานเดิมโดยไม่สร้างใบแจ้งหนี้ซ้ำ",
    "outcome": "บัญชีได้เอกสารครบที่ตรวจแล้ว หลักฐานที่ขาดมีคนรับผิดชอบก่อนทำให้บิลล่าช้า",
    "measures": [
      "เวลาจากส่งมอบถึงออกบิล",
      "งานเสร็จที่ยังรอเอกสาร",
      "บิลที่ถูกโต้แย้งเพราะขาดหลักฐาน"
    ],
    "systems": "ระบบขนส่ง, ฟอร์มคนขับ, ที่เก็บเอกสาร, บัญชี"
  },
  {
    "id": "healthcare",
    "industry": "สถานพยาบาลและคลินิก",
    "function": "บริการลูกค้า",
    "title": "เติมเวลานัดที่ยกเลิกโดยไม่จองซ้ำ",
    "summary": "ประสานการยืนยัน ยกเลิก และรายชื่อรอด้วยปฏิทินปัจจุบัน",
    "situation": "พนักงานต้อนรับโทรหาผู้ป่วยระหว่างรับบริการ การยกเลิกอยู่ในข้อความแต่ไม่อยู่ในระบบ พนักงานสองคนเสนอเวลาเดียวกันให้คนละคน",
    "steps": [
      "อ่านสถานะจากระบบนัดหมายและส่งข้อความเตือนที่อนุมัติผ่านช่องทางที่ผู้ป่วยเลือก",
      "บันทึกการยืนยันและยกเลิก แล้วเสนอเวลาว่างให้รายชื่อรอที่เข้าเกณฑ์คลินิก",
      "กันเวลาระหว่างรอคำตอบ ปล่อยข้อเสนอที่หมดเวลา และส่งคำขอค้างให้พนักงาน"
    ],
    "control": "ข้อความมีเฉพาะเรื่องนัดหมาย คำถามทางคลินิกส่งให้เจ้าหน้าที่ ไม่วินิจฉัย ประเมินความเร่งด่วน หรือแนะนำการรักษาอัตโนมัติ",
    "outcome": "พนักงานเห็นตารางล่าสุดเดียวกันและเสนอเวลาที่ว่างได้โดยไม่จองขัดกัน",
    "measures": [
      "เวลาที่ยกเลิกและยังว่าง",
      "เวลาที่ใช้ยืนยันนัด",
      "อัตราการมาตามนัด"
    ],
    "systems": "ระบบนัดหมายคลินิก, ข้อมูลความยินยอม, ข้อความ, คิวงานเจ้าหน้าที่"
  },
  {
    "id": "property",
    "industry": "อสังหาริมทรัพย์",
    "function": "ปฏิบัติการและการส่งมอบ",
    "title": "ติดตามงานซ่อมผู้เช่าและการนัดช่าง",
    "summary": "ส่งต่องานซ่อมตั้งแต่ข้อความแรกจนปิดงาน",
    "situation": "รูปอยู่ในแชตตัวแทน ช่างได้รับข้อความส่งต่อ และเจ้าของถูกขออนุมัติแยก ผู้เช่าจึงตามงานเพราะไม่มีสถานะร่วม",
    "steps": [
      "สร้างงานซ่อมพร้อมทรัพย์สิน ห้อง ปัญหา รูป และวิธีเข้าพื้นที่ เชื่อมรายงานซ้ำกับงานเดิม",
      "ส่งงานตามกติกาของทรัพย์สิน ขออนุมัติค่าใช้จ่าย และนัดช่างที่ว่าง",
      "ติดตามการเข้าพื้นที่และหลักฐานงานเสร็จ ขอผู้เช่ายืนยัน และเทียบบิลช่างกับงานที่อนุมัติ"
    ],
    "control": "รายงานเร่งด่วนหรือไม่ชัดเจนส่งให้ผู้รับผิดชอบ แสดงคำแนะนำฉุกเฉิน และขอเจ้าของอนุมัติงานค่าใช้จ่ายสูง",
    "outcome": "ผู้เช่า ตัวแทน และช่างเห็นขั้นตอนถัดไป ผู้จัดการเห็นงานที่ค้าง",
    "measures": [
      "เวลามอบหมายช่าง",
      "งานเกินกำหนด",
      "การติดตามซ้ำต่อการซ่อม"
    ],
    "systems": "ข้อมูลทรัพย์สิน, ฟอร์มหรือข้อความ, ปฏิทินช่าง, บัญชี"
  },
  {
    "id": "construction",
    "industry": "ก่อสร้างและงานช่าง",
    "function": "การเงินและกระแสเงินสด",
    "title": "อนุมัติงานเปลี่ยนแปลงก่อนเรียกเก็บเงิน",
    "summary": "บันทึกการเปลี่ยนขอบเขตก่อนข้อมูลหายในข้อความหน้างาน",
    "situation": "ลูกค้าขอเปลี่ยนงาน ทีมเริ่มทำ รูปอยู่ในโทรศัพท์หัวหน้างาน สำนักงานเพิ่งทราบตอนเตรียมเบิก ลูกค้าโต้แย้งสิ่งที่ตกลง",
    "steps": [
      "บันทึกการเปลี่ยนในโครงการ พร้อมคำขอ รูป ขอบเขตที่กระทบ และผู้ติดต่อ",
      "ร่างงานเปลี่ยนแปลงโดยใช้ราคาและกำหนดการจากผู้ประเมิน ส่งตามขั้นตอนอนุมัติ",
      "ติดตามการตัดสินใจ และนำงานที่อนุมัติเข้างบและเอกสารเบิกความก้าวหน้า"
    ],
    "control": "ผู้จัดการอนุมัติราคา ข้อความสัญญา และคำสั่งเริ่มงาน ร่างหรืออีเมลที่ส่งไม่ถือว่าลูกค้ายอมรับ",
    "outcome": "งานที่อนุมัติมีหลักฐาน และมองเห็นงานที่ยังไม่อนุมัติก่อนเบิกครั้งถัดไป",
    "measures": [
      "มูลค่างานเปลี่ยนแปลงที่ยังไม่อนุมัติ",
      "เวลาจากคำขอถึงตัดสินใจ",
      "รายการเบิกที่คืนเพราะขาดหลักฐาน"
    ],
    "systems": "ฟอร์มหน้างาน, ข้อมูลโครงการ, ชีตประเมินราคา, ระบบอนุมัติ"
  },
  {
    "id": "hospitality",
    "industry": "โรงแรมและการท่องเที่ยว",
    "function": "บริการลูกค้า",
    "title": "ส่งต่อคำขอแขกให้ครบเมื่อเปลี่ยนกะ",
    "summary": "ให้คำขอแขกมีเจ้าของงานข้ามฝ่ายจอง ต้อนรับ และแม่บ้าน",
    "situation": "คำขอเข้าพักเร็วมาในช่องทางจอง คำขออาหารมาอีกอีเมล เมื่อเปลี่ยนกะทีมมีเลขจองแต่ไม่รู้สิ่งที่รับปาก",
    "steps": [
      "จับคู่ข้อความกับการจองและบันทึกแต่ละคำขอในข้อมูลบริการร่วม",
      "มอบหมายตามแผนกและเวลาเข้าพัก ตรวจห้องหรือบริการก่อนร่างคำตอบ",
      "ติดตามการรับงาน ส่งงานเกินกำหนดให้ผู้จัดการเวร และรวมสิ่งที่ยังต้องทำในบันทึกส่งกะ"
    ],
    "control": "พนักงานอนุมัติอัปเกรด คืนเงิน และคำมั่นที่ขึ้นกับความพร้อม ข้อมูลอ่อนไหวส่งเฉพาะทีมรับผิดชอบ",
    "outcome": "แต่ละกะเห็นสิ่งที่แขกต้องการ สิ่งที่รับปาก และงานที่เหลือ",
    "measures": [
      "คำขอค้างเมื่อแขกมาถึง",
      "เวลารับทราบคำขอ",
      "สิ่งที่รับปากแล้วพลาดต่อการเข้าพัก"
    ],
    "systems": "ระบบจัดการโรงแรม, ช่องทางจอง, อีเมลร่วม, บอร์ดงานทีม"
  },
  {
    "id": "food",
    "industry": "อาหารและเครื่องดื่ม",
    "function": "ปฏิบัติการและการส่งมอบ",
    "title": "วางแผนสั่งของตามสต็อกและวันหมดอายุ",
    "summary": "รวมยอดสต็อก ความต้องการ และเวลาปิดรับคำสั่งซื้อ",
    "situation": "สาขาส่งยอดในแชตคนละรูปแบบ สำนักงานรวมยอดหลังปิดรับสั่ง และมองไม่เห็นของใกล้หมดอายุที่สาขาใกล้กัน จึงสั่งของเดิมเพิ่ม",
    "steps": [
      "เก็บยอดตามสาขา สินค้า หน่วย และล็อตวันหมดอายุ แจ้งข้อมูลขาดหรือเปลี่ยนผิดปกติ",
      "รวมความต้องการ สต็อกที่ใช้ได้ และเวลาจัดส่ง เพื่อร่างข้อเสนอเติมหรือโอนของ",
      "ส่งร่างให้ผู้จัดการก่อนปิดรับ และบันทึกยอดรับไม่ตรงกับคำสั่งซื้อที่อนุมัติ"
    ],
    "control": "ผู้จัดการอนุมัติการสั่งและโอน ต้องตรวจการแปลงหน่วย อายุสินค้า และข้อจำกัดจัดการอาหารก่อนใช้ข้อเสนอ",
    "outcome": "จัดซื้อใช้ข้อมูลล่าสุด พร้อมเห็นของขาดและของใกล้หมดอายุ",
    "measures": [
      "ครั้งที่สินค้าขาดต่อสาขา",
      "มูลค่าของหมดอายุหรือสูญเสีย",
      "เวลารวมคำสั่งซื้อ"
    ],
    "systems": "POS, ฟอร์มนับสต็อก, สินค้าคงคลัง, ข้อมูลสั่งซื้อผู้ขาย"
  },
  {
    "id": "saas",
    "industry": "SaaS และเทคโนโลยี",
    "function": "การขายและเริ่มใช้งาน",
    "title": "ส่งต่องานเริ่มใช้งานของลูกค้าใหม่ให้ครบ",
    "summary": "ส่งต่อจากฝ่ายขายสู่ทีมเริ่มใช้งานพร้อมผู้รับผิดชอบ",
    "situation": "ฝ่ายขายปิดดีล แต่ทีมติดตั้งไม่ได้ขอบเขตที่รับปาก เจ้าของบัญชี หรือข้อกำหนดเชื่อมต่อ ลูกค้าต้องเล่าข้อมูลซ้ำและรอสิทธิ์เข้าใช้",
    "steps": [
      "ตรวจดีลที่ปิดแล้วว่ามีขอบเขตลงนาม ผู้ติดต่อ สิ่งที่รับปาก และข้อมูลตั้งค่า",
      "สร้างแผนเริ่มใช้งานจากแพ็กเกจ มอบหมายเจ้าของงาน และขอเฉพาะข้อมูลที่ขาด",
      "ติดตามขั้นตอนตั้งค่าและสัญญาณใช้งานที่อนุมัติ แจ้งเจ้าของเมื่อลูกค้าค้างก่อนเกิดผลที่เป็นประโยชน์"
    ],
    "control": "เจ้าของบัญชีแก้ขอบเขตที่ขัดกัน ให้สิทธิ์ตามบทบาทที่อนุมัติ และไม่เก็บข้อมูลลับในงาน CRM",
    "outcome": "ลูกค้าใหม่ได้การส่งต่อครบและเส้นทางสู่คุณค่าจากผลิตภัณฑ์ที่เห็นได้",
    "measures": [
      "วันจากลงนามถึงคุณค่าครั้งแรก",
      "งานเริ่มใช้งานเกินกำหนด",
      "ครั้งที่ขอข้อมูลลูกค้าซ้ำ"
    ],
    "systems": "CRM, ข้อมูลสัญญา, เครื่องมือโครงการ, เหตุการณ์ใช้งานผลิตภัณฑ์"
  },
  {
    "id": "professional",
    "industry": "เอเจนซีและบริการวิชาชีพ",
    "function": "การเงินและกระแสเงินสด",
    "title": "เห็นโครงการเกินงบก่อนออกบิล",
    "summary": "เชื่อมขอบเขต เวลา และการเรียกเก็บก่อนสิ้นเดือน",
    "situation": "คำขอเล็ก ๆ มาในแชต เวลาอยู่ในโครงการหลัก โควตางานใกล้หมด ผู้ดูแลบัญชีเพิ่งเห็นยอดเกินตอนทำบิล",
    "steps": [
      "เทียบขอบเขตและโควตาที่อนุมัติกับเวลาบันทึก ผลงาน และงานที่รับปาก",
      "แจ้งเมื่อถึงเกณฑ์งบหรือคำขอนอกขอบเขต พร้อมแนบรายการต้นทาง",
      "เตรียมข้อมูลให้ผู้ดูแลบัญชีตรวจ และนำงานเพิ่มที่อนุมัติเข้าร่างบิลถัดไป"
    ],
    "control": "ผู้ดูแลบัญชีตัดสินใจว่างานใดคิดเงินและคุยการเปลี่ยนกับลูกค้า ไม่ส่งบิลที่ลูกค้าไม่ทราบโดยอัตโนมัติ",
    "outcome": "เจ้าของโครงการเห็นแนวโน้มเกินงบทันปรับขอบเขต คน หรือข้อตกลง",
    "measures": [
      "งานอนุมัติที่ยังไม่เรียกเก็บ",
      "เวลารวบรวมร่างบิล",
      "โครงการเกินโควตาที่ตกลง"
    ],
    "systems": "จัดการโครงการ, บันทึกเวลา, CRM, บัญชี"
  },
  {
    "id": "education",
    "industry": "การศึกษาและฝึกอบรม",
    "function": "การขายและเริ่มใช้งาน",
    "title": "ประสานเอกสารสมัคร เงิน และที่นั่งเรียน",
    "summary": "ให้ใบสมัคร เอกสาร การชำระเงิน และจำนวนที่นั่งตรงกัน",
    "situation": "ฝ่ายรับสมัครเก็บฟอร์ม การเงินตรวจเงิน ผู้ประสานงานนับที่นั่ง ผู้เรียนได้คำตอบต่างกันสามแบบว่าลงทะเบียนสำเร็จหรือยัง",
    "steps": [
      "สร้างข้อมูลสมัครเดียวและตรวจฟิลด์กับเอกสารตามรายการของหลักสูตร",
      "จับคู่หลักฐานจ่ายและที่นั่ง แล้วขอเฉพาะสิ่งที่ขาดพร้อมกำหนดเวลา",
      "ยืนยันเมื่อผ่านการตรวจที่จำเป็นเท่านั้น และสร้างงานเริ่มเรียน"
    ],
    "control": "เจ้าหน้าที่ตัดสินใจรับสมัครและคุณสมบัติ การจ่ายไม่ชัด ใบสมัครซ้ำ หรือที่นั่งขัดกันส่งให้ตรวจ",
    "outcome": "ผู้เรียนรู้สิ่งที่ขาด ผู้ประสานงานแยกผู้สอบถามจากผู้ลงทะเบียนสำเร็จได้",
    "measures": [
      "เวลาจากสมัครถึงยืนยัน",
      "ใบสมัครไม่ครบที่รอติดตาม",
      "แรงงานจับคู่การจ่ายด้วยมือ"
    ],
    "systems": "ฟอร์มสมัคร, ข้อมูลนักเรียน, ข้อมูลชำระเงิน, ปฏิทินหลักสูตร"
  },
  {
    "id": "recruitment",
    "industry": "จัดหางานและบุคลากร",
    "function": "บุคลากรและธุรการ",
    "title": "เตรียมเอกสารเข้าทำงานให้ครบก่อนวันเริ่ม",
    "summary": "ประสานเอกสาร ลายเซ็น และความพร้อมวันแรก",
    "situation": "ยืนยันการรับคนแล้วแต่ฝ่ายเงินเดือนรอฟอร์ม ลูกค้ายังไม่ยืนยันปฐมนิเทศ ไม่มีใครเห็นงานค้างจนผู้สมัครถามว่าจะไปที่ไหนวันจันทร์",
    "steps": [
      "สร้างรายการตรวจตามตำแหน่งและข้อกำหนดลูกค้าหลังบันทึกการตัดสินใจจ้าง",
      "ขอเอกสารขาดผ่านช่องทางปลอดภัยที่อนุมัติ ติดตามโดยไม่คัดลอกไฟล์อ่อนไหวเข้าแชต",
      "ประสานลงนาม ส่งต่อเงินเดือน และยืนยันปฐมนิเทศ แจ้งงานไม่ครบก่อนวันเริ่ม"
    ],
    "control": "คนตรวจตัวตน สิทธิ์ทำงาน และรายละเอียดสัญญา ระบบไม่ให้คะแนนผู้สมัครหรือตัดสินใจจ้าง",
    "outcome": "ผู้จัดหางานเห็นคนที่พร้อมเริ่มและขั้นตอนที่ทำให้คนอื่นค้าง",
    "measures": [
      "คนที่พร้อมก่อนวันเริ่ม",
      "เวลาตามเอกสารต่อคน",
      "การเริ่มงานล่าช้าเพราะธุรการ"
    ],
    "systems": "ระบบติดตามผู้สมัคร, พอร์ทัลเอกสารปลอดภัย, ลายเซ็นอิเล็กทรอนิกส์, งานเงินเดือน"
  },
  {
    "id": "insurance",
    "industry": "ประกันภัย",
    "function": "บริการลูกค้า",
    "title": "ขอเอกสารเคลมที่ขาดให้ชัดในครั้งเดียว",
    "summary": "ตรวจความครบถ้วนและส่งคิวตรวจที่มีเจ้าของ",
    "situation": "ผู้เอาประกันส่งไฟล์หลายอีเมล ผู้ดูแลเปิดเคสแล้วเพิ่งพบเอกสารขาด คำขอทั่วไปทำให้ลูกค้าส่งทุกอย่างใหม่",
    "steps": [
      "จับคู่เอกสารกับเลขเคลมและจัดดัชนีไฟล์ต้นฉบับโดยไม่ทับเวอร์ชันเดิม",
      "ตรวจตามรายการที่อนุมัติของประเภทเคลม และร่างคำขอเฉพาะสิ่งที่ขาด",
      "ส่งชุดเอกสารครบให้ผู้ดูแล ติดตามเวลารอลูกค้าแยกจากเวลาตรวจภายใน"
    ],
    "control": "ผู้ดูแลประเมินความคุ้มครอง ความรับผิด และเงินชดเชย เอกสารจับคู่ไม่แน่หรืออ่อนไหวอยู่ในคิวจำกัดสิทธิ์",
    "outcome": "ลูกค้าได้คำขอเฉพาะ ผู้ดูแลใช้เวลาประกอบเอกสารน้อยลงก่อนประเมิน",
    "measures": [
      "เวลาจนไฟล์เคลมครบ",
      "จำนวนคำขอเอกสารซ้ำ",
      "เคลมที่รอโดยไม่มีผู้ดูแล"
    ],
    "systems": "ระบบเคลม, ช่องทางรับปลอดภัย, ที่เก็บเอกสาร, การติดต่อที่อนุมัติ"
  },
  {
    "id": "financial",
    "industry": "บริการทางการเงิน",
    "function": "บุคลากรและธุรการ",
    "title": "เตรียมแฟ้มทบทวนลูกค้าก่อนครบกำหนด",
    "summary": "รวมหลักฐานและส่งข้อยกเว้นพร้อมบันทึกการตัดสินใจ",
    "situation": "ฝ่ายปฏิบัติการตรวจวันต่ออายุในชีต ขอเอกสารทางอีเมล และรวมแฟ้มเอง ข้อมูลขาดเพิ่งพบหลังส่งให้ผู้ตรวจ",
    "steps": [
      "สร้างงานจากกำหนดการที่อนุมัติ และระบุหลักฐานที่จำเป็นต่อรายการ",
      "รับข้อมูลผ่านช่องทางที่อนุมัติ ตรวจความครบและวันหมดอายุ เก็บเวอร์ชันต้นฉบับ",
      "เตรียมแฟ้มจำกัดสิทธิ์ ระบุข้อมูลขาดหรือขัดกัน บันทึกผลตรวจและงานติดตาม"
    ],
    "control": "ผู้ตรวจที่ได้รับสิทธิ์ตัดสินใจเรื่องข้อกำหนด บัญชี และความเสี่ยง ระบบจัดหลักฐาน ไม่รับรองการปฏิบัติตามหรืออนุมัติลูกค้า",
    "outcome": "ผู้ตรวจได้แฟ้มเป็นระเบียบและรายการข้อยกเว้นแทนการประกอบเคสเอง",
    "measures": [
      "เวลาเตรียมต่อการทบทวน",
      "งานทบทวนเกินกำหนด",
      "แฟ้มคืนเพราะหลักฐานไม่ครบ"
    ],
    "systems": "ข้อมูลลูกค้า, พอร์ทัลเอกสารที่อนุมัติ, คิวตรวจ, บันทึกตรวจสอบ"
  },
  {
    "id": "energy",
    "industry": "พลังงานและบริการภาคสนาม",
    "function": "ปฏิบัติการและการส่งมอบ",
    "title": "ให้วิศวกรมีอะไหล่และประวัติงานครบก่อนออกหน้างาน",
    "summary": "เตรียมงานบริการพร้อมข้อมูลอุปกรณ์ อะไหล่ และวิธีเข้าพื้นที่",
    "situation": "แจ้งเครื่องเสียทางอีเมล จองงานโดยไม่มีเลขเครื่องหรือประวัติซ่อม วิศวกรพบปัญหาที่เคยเกิดแล้วต้องกลับมาซ่อมอีกรอบ",
    "steps": [
      "จับคู่คำขอกับอุปกรณ์และสถานที่ เก็บอาการ ประวัติ และข้อกำหนดเข้าพื้นที่",
      "เตรียมชุดงาน ตรวจคุณสมบัติช่าง อะไหล่ และเวลาลูกค้าก่อนเสนอวันนัด",
      "เก็บรายงานและอะไหล่ที่ใช้ ส่งปัญหาค้างและงานติดตามให้ผู้ประสานงาน"
    ],
    "control": "เจ้าหน้าที่ที่มีคุณสมบัติตัดสินใจเรื่องความปลอดภัยและวิธีซ่อม ส่งต่อปัญหาเร่งด่วน ระบบนี้ไม่ควบคุมอุปกรณ์ระยะไกล",
    "outcome": "ผู้ประสานงานเตรียมการเข้าพื้นที่ครบและเห็นงานที่ยังไม่พร้อมส่งช่าง",
    "measures": [
      "การเข้าซ้ำเพราะข้อมูลขาด",
      "งานที่ส่งพร้อมข้อมูลครบ",
      "เวลาจากแจ้งถึงนัด"
    ],
    "systems": "ทะเบียนอุปกรณ์, ระบบรับงานบริการ, คลังอะไหล่, ตารางนัด"
  },
  {
    "id": "agriculture",
    "industry": "เกษตรและห่วงโซ่อาหาร",
    "function": "ปฏิบัติการและการส่งมอบ",
    "title": "ติดตามล็อตตั้งแต่รับเข้า บรรจุ จนส่งออก",
    "summary": "เชื่อมล็อตรับเข้า ข้อมูลบรรจุ และขนส่งเพื่อตรวจย้อนหลัง",
    "situation": "สินค้าจากเกษตรกรมีเลขล็อตเขียนมือ การบรรจุสร้างรหัสใหม่ ฝ่ายส่งบันทึกลูกค้าแยก คำถามคุณภาพต้องโทรไล่ข้อมูล",
    "steps": [
      "เก็บล็อตผู้ขาย วันที่รับ จำนวน และเอกสารต้นทางด้วยรหัสที่สอดคล้องกัน",
      "เชื่อมล็อตรับเข้ากับล็อตบรรจุและการส่งออก โดยเก็บการแยกและรวมล็อต",
      "เตรียมหลักฐานของล็อตที่สอบถาม แสดงสต็อก การส่ง และลูกค้าที่กระทบ มอบหมายผู้ดูแลช่องว่างข้อมูล"
    ],
    "control": "ฝ่ายคุณภาพตัดสินใจกัก ปล่อย หรือเรียกคืน ช่องเชื่อมที่ขาดต้องแจ้ง ระบบไม่อนุมานประวัติที่ไม่ได้บันทึก",
    "outcome": "ฝ่ายคุณภาพได้ประวัติล็อตชัดเจนและเห็นช่องว่างก่อนคำถามเร่งด่วน",
    "measures": [
      "เวลาเตรียมหลักฐานย้อนหลัง",
      "ล็อตที่ข้อมูลเชื่อมไม่ครบ",
      "เวลาตรวจเทียบด้วยมือ"
    ],
    "systems": "ฟอร์มรับเข้า, ข้อมูลล็อต, สินค้าคงคลัง, ข้อมูลส่งออก"
  },
  {
    "id": "nonprofit",
    "industry": "องค์กรไม่แสวงกำไรและสมาคม",
    "function": "การเงินและกระแสเงินสด",
    "title": "เตรียมหลักฐานทุนให้พร้อมตลอดรอบรายงาน",
    "summary": "เชื่อมกิจกรรม ค่าใช้จ่ายที่อนุมัติ และเอกสารตลอดโครงการทุน",
    "situation": "ฝ่ายโครงการบันทึกกิจกรรมในชีต การเงินลงค่าใช้จ่ายแยก สัปดาห์รายงานจึงต้องหาใบเสร็จ เทียบยอด และอธิบายกิจกรรมที่ทุนสนับสนุน",
    "steps": [
      "ผูกค่าใช้จ่ายอนุมัติและกิจกรรมกับทุน รอบรายงาน และหมวดงบที่ตกลง",
      "ตรวจใบเสร็จขาด รหัสไม่ตรง และข้อยกเว้นงบ มอบหมายเจ้าของข้อมูลแก้",
      "เตรียมร่างรายงานพร้อมหลักฐานเชื่อมและยอดที่ตรวจตรงให้หัวหน้าโครงการกับการเงิน"
    ],
    "control": "เจ้าหน้าที่อนุมัติคุณสมบัติ การจัดสรร และรายงานส่งผู้ให้ทุน ข้อมูลผู้รับประโยชน์จำกัดสิทธิ์และไม่รวมเว้นแต่จำเป็นและได้รับอนุญาต",
    "outcome": "เริ่มรายงานจากหลักฐานที่ดูแลต่อเนื่อง เห็นสิ่งที่ขาดก่อนกำหนด",
    "measures": [
      "ชั่วโมงเตรียมแต่ละรายงาน",
      "ค่าใช้จ่ายที่ขาดหลักฐาน",
      "การแก้ไขที่ขอระหว่างตรวจ"
    ],
    "systems": "ข้อมูลโครงการ, บัญชี, ที่เก็บเอกสาร, แบบรายงานผู้ให้ทุน"
  }
];
